import { render } from "./SideBarNav.vue?vue&type=template&id=16c0ba12"
import script from "./SideBarNav.vue?vue&type=script&lang=js"
export * from "./SideBarNav.vue?vue&type=script&lang=js"

import "./SideBarNav.vue?vue&type=style&index=0&id=16c0ba12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SideBarNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16c0ba12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16c0ba12', __exports__)) {
    api.reload('16c0ba12', __exports__)
  }
  
  module.hot.accept("./SideBarNav.vue?vue&type=template&id=16c0ba12", () => {
    api.rerender('16c0ba12', render)
  })

}


export default __exports__